import { useCallback, useMemo, useState } from "react";
import { getTranslatedField } from "../../utils/lang";
import Icon from "../icon";
import CancelEventBookingModal from "./cancel-event-booking-modal";
import StageCard from "./stage-card";
import dayjs from "dayjs";

const EventFeedback = ({
  reservation,
  labels,
  appLang,
  eventNavigation,
  setEventNavigation,
  setCancelledToast,
  eventId,
  setReservation,
  event,
}) => {
  const [discardModal, setDiscardModal] = useState(false);

  const handleEditBooking = useCallback(() => {
    setEventNavigation(null);
  }, [setEventNavigation]);

  const handleCancelBooking = useCallback(() => setDiscardModal(true), []);

  const translatedEvent = useMemo(
    () => ({
      logistics: getTranslatedField(event, appLang, "logistics"),
      contacts: getTranslatedField(event, appLang, "contacts"),
    }),
    [appLang, event]
  );

  const hideBooking = useMemo(
    () => dayjs().isBefore(dayjs(Number(reservation?.stage?.registrationEnd))),
    [reservation]
  );

  return (
    <div className="wrapper wrapper-small event__feedback">
      <div
        className="event__text event__text--big"
        dangerouslySetInnerHTML={{
          __html:
            eventNavigation?.url === "booked"
              ? labels?.EVENT_DETAIL_BOOKED_DESCRIPTION ||
                "<strong>We'll wait for you at this event:</strong>"
              : labels?.EVENT_DETAIL_WAITING_LIST_CAPTION ||
                "<strong>We have registered your request to participate at this event<strong>",
        }}
      />
      <StageCard stage={reservation?.stage} appLang={appLang} labels={labels} />
      {eventNavigation?.url === "waiting-list" && (
        <div
          className="event__text event__sold-out-description"
          dangerouslySetInnerHTML={{
            __html:
              labels?.EVENT_SOLD_OUT_DESCRIPTION ||
              "<p>At the moment the event is sold out.<br/><strong>We will send you an email if there will be any available seats.</strong></p>",
          }}
        />
      )}
      <div className="event__resume">
        <h2>{labels?.EVENT_YOUR_DATA || "Your data"}</h2>
        <div>
          {labels?.EVENT_SURVEY_EMAIL || "Mail"}: {reservation?.email}
        </div>
        {!!reservation?.guestFullName && (
          <div>
            {labels?.EVENT_SURVEY_GUEST_NAME || "Guest"}: {reservation?.guestFullName}
          </div>
        )}
        {!!reservation?.transferNeeded && (
          <div>
            {labels?.EVENT_SURVEY_TRANSFER || "Transfer"}:{" "}
            {reservation?.transferNeeded
              ? labels?.EVENT_TRANSFER_YES || "Yes"
              : labels?.EVENT_TRANSFER_NO || "No"}
          </div>
        )}
      </div>
      {eventNavigation?.url === "booked" && (
        <div className="event__feedback-info">
          {translatedEvent?.logistics && (
            <div dangerouslySetInnerHTML={{ __html: translatedEvent.logistics }} />
          )}
          {translatedEvent?.contacts && (
            <div dangerouslySetInnerHTML={{ __html: translatedEvent.contacts }} />
          )}
        </div>
      )}
      <div className="event__actions">
        {hideBooking ? (
          <button className="link link--accent" onClick={handleEditBooking}>
            <span>{labels?.EVENT_CHANGE_BOOKING || "Change booking"}</span>
            <Icon name="pencil" className="pencil" />
          </button>
        ) : (
          <span className="event__info-date">
            {labels?.EVENT_CANCEL_BOOKING_INFO ||
              "La fase di iscrizione a questo evento è chiusa, se decidi di cancellare la tua partecipazione non potrai iscriverti nuovamente"}
          </span>
        )}
        {event?.registrationCancelEnabled && (
          <button className="link link--accent" onClick={handleCancelBooking}>
            <span>{labels?.EVENT_CANCEL_BOOKING || "Cancel booking"}</span>
            <Icon name="trash" />
          </button>
        )}
      </div>
      <CancelEventBookingModal
        key={!!discardModal}
        show={discardModal}
        setShow={setDiscardModal}
        labels={labels}
        setCancelledToast={setCancelledToast}
        setEventNavigation={setEventNavigation}
        eventId={eventId}
        setReservation={setReservation}
      />
    </div>
  );
};
export default EventFeedback;
